module.exports = __webpack_public_path__ + "static/media/support_light.b6df48b6.svg";